import { render, staticRenderFns } from "./orgRuleDialog.vue?vue&type=template&id=dd8233dc&scoped=true"
import script from "./orgRuleDialog.vue?vue&type=script&lang=js"
export * from "./orgRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./orgRuleDialog.vue?vue&type=style&index=0&id=dd8233dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8233dc",
  null
  
)

export default component.exports